import * as config from '../services/config';
import axios from 'axios';

const baseURL = config.rootURL;

const instance = axios.create();
instance.interceptors.request.use(function (config) {

    var url = baseURL + config?.url;
    config.url = url;
    return config;
}, function (error) {
    console.log('err', error);
    return Promise.reject(error);
});


instance.interceptors.response.use(function (response) {
    return response;

}, function (error) {
    console.log('err', error);
    
    return Promise.reject(error);
});

export default instance;